<template>
  <div id="app" ref="appEntry" v-if="$store.state.isAppLoaded">
    <LogoutButton v-if="$store.getters['authAdmin/hasAdminRights']"></LogoutButton>
    <LanguageSelector v-if="!isMobile"></LanguageSelector>
    <Topbar></Topbar>


    <div id="content">
      <GlobalSearchBar />
      <transition name="global-drawer-slide">
        <MobileNavigationOverlay v-if="isGlobalDrawerOpen && isMobile"></MobileNavigationOverlay>

      </transition>
      <transition name="global-search-overlay-transition">
        <GlobalSearchOverlay v-if="isGlobalSearchOverlayOpen" :value="globalSearchFilter"
          @input="updateGlobalSearchFilter" @close="closeGlobalSearchOverlay"></GlobalSearchOverlay>
      </transition>
      <router-view style="padding-top: 15px" />
      <CopyrightBar></CopyrightBar>
    </div>
    <div id="sponsor-bar">
      <img class="sponsor-image" v-if="$store.state.admin" :src="$store.state.admin.sponsor_url" />
    </div>
  </div>
</template>

<script>
import Topbar from "@/components/Topbar.vue";
import LanguageSelector from "@/components/LanguageSelector.vue";
import Loading from "@/components/Loading.vue";
import LogoutButton from "@/components/App/UI/LogoutButton.vue";
import CopyrightBar from "@/components/App/CopyrightBar.vue";
import WaitingQueueService from '@/services/waiting-queue.service';
import GlobalSearchBar from "@/components/App/GlobalSearchBar.vue";
import GlobalSearchOverlay from "@/components/App/GlobalSearchOverlay.vue";
import MobileNavigationOverlay from "@/components/App/MobileNavigationOverlay.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: { Topbar, Loading, LanguageSelector, LogoutButton, CopyrightBar, GlobalSearchBar, GlobalSearchOverlay, MobileNavigationOverlay },
  computed: {
    ...mapState("ui", ["isGlobalDrawerOpen", "isGlobalSearchOverlayOpen", "globalSearchFilter"]),
    ...mapGetters(["isMobile"]),
    hasFullscreenOverlay() {
      return this.$store.getters["ui/hasFullscreenOverlay"];
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.name != "live") {
        this.$store.commit("clearRefreshIntervals");
      }
      if (this.$store.state.module.nom) {
        document.title = this.$store.state.module.nom + " | " + to.name;
      } else {
        document.title = "Sportips | " + to.meta.title;
      }
      this.closeAllGlobal();
    },
    "$store.state.module"(newVal, from) {
      if (this.$store.state.module.nom) {
        document.title = this.$store.state.module.nom + " | " + this.$route.name;
      } else {
        document.title = "Sportips";
      }
    },
    hasFullscreenOverlay() {
      this.syncBodyOverflow();
    },
    isMobile(isMobile) {
      if (!isMobile) {
        this.closeAllGlobal();
      }
    },
  },
  methods: {
    ...mapActions("ui", ["closeGlobalDrawer", "closeGlobalSearchOverlay", "updateGlobalSearchFilter", "closeAllGlobal"]),
    updateViewportWidth() {
      this.$store.commit("setViewportWidth", window.innerWidth);
    },
    syncBodyOverflow() {
      document.body.style.overflow = this.hasFullscreenOverlay ? "hidden" : "";
    },
    applyAdminTheme() {
      const a = this.$store.state.admin;
      if (!a) return;
      const el = this.$el || this.$root.$el || document.getElementById("app") || document.documentElement;
      if (!el || !el.style) return;
      el.style.setProperty("--primary-color", a.primary_color);
      el.style.setProperty("--background-color", a.background_color);
      el.style.setProperty("--footer-color", a.footer_color);
      el.style.setProperty("--header-image", "url('" + a.header_url + "')");
      el.style.setProperty("--footer-image", "url('" + a.footer_url + "')");
      this.$forceUpdate();
    },
  },
  async created() {
    this.updateViewportWidth();
    window.addEventListener("resize", this.updateViewportWidth);

    const isAdminOrPcCourse =
      this.$store.getters["authAdmin/isLogged"] ||
      this.$route.name === "PCCourse";
    if (!isAdminOrPcCourse) {
      await WaitingQueueService.init();
      setInterval(async () => {
        await WaitingQueueService.init();
      }, 60000);
    }


    await this.$store.dispatch("fetchModule", this.$route.params.base);
    this.$store.commit("setVisibilityParticipantsTab");
    await this.$store.dispatch("initAdminAndParcours");
    this.$store.commit("setIsAppLoaded", true);
    this.$store.commit("setHideNbInscrits", this.$route.params.base);
    this.$nextTick(() => {
      this.applyAdminTheme();
    });
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    window.removeEventListener("resize", this.updateViewportWidth);
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rubik:wght@400;500;700&display=swap");

#app {
  --primary-color: #f29200;
  --background-color: #e9f1f3;
  --footer-color: #2f3a45;
  --header-image: url("https://sportips.fr/race/uploads/topbar_bg.jpg");
}

@import "./scss/style.scss";
</style>
